/* eslint-disable tree-shaking/no-side-effects-in-initialization -- plugin doesn't handle JSX node */
import React from "react";

import { createCustomIcon } from "./createCustomIcon";

/** See https://www.notion.so/hexhq/How-to-Adding-a-new-Custom-Icon-914117a2642148e09b257605075dcfc0 for guidance */

export const ChartCellIcon = createCustomIcon({
  name: "Chart cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M1 1.985h1v13h13v1H1v-14Zm13.941 2.618-4.655 6.517a.5.5 0 0 1-.807.01L7.11 7.97l-3.332 5-.832-.556L6.67 6.828a.5.5 0 0 1 .816-.022L9.87 9.983l4.259-5.961.813.581Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CodeCellIcon = createCustomIcon({
  name: "Code cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M6.302 15.147 8.712.688l.986.165-2.41 14.459-.986-.165ZM5.092 4.385 1.478 8l3.614 3.615-.707.707L.063 8l4.322-4.322.707.707Zm6.523-.707L15.937 8l-4.322 4.322-.707-.707L14.522 8l-3.614-3.615.707-.707Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const FilterCellIcon = createCustomIcon({
  name: "Filter cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5ZM3 7.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5ZM5 11.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MapCellIcon = createCustomIcon({
  name: "Map cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M5.752 2.066a.5.5 0 0 1 .472-.013l3.76 1.88 3.268-1.867A.5.5 0 0 1 14 2.5V11a.5.5 0 0 1-.21.407l-3.5 2.5a.5.5 0 0 1-.514.04l-3.76-1.88-3.268 1.867A.5.5 0 0 1 2 13.5v-9a.5.5 0 0 1 .252-.434l3.5-2ZM3 4.79l2.5-1.428v7.848L3 12.638V4.79Zm6.5 7.901-3-1.5V3.309l3 1.5v7.882Zm1-.163 2.5-1.785V3.362L10.5 4.79v7.738Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MarkdownCellIcon = createCustomIcon({
  name: "Markdown cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M0 11.74c0 .879.72 1.593 1.605 1.593h12.79c.885 0 1.605-.714 1.605-1.593V4.26c0-.879-.72-1.593-1.605-1.593H1.605C.72 2.667 0 3.38 0 4.26v7.478Zm1-7.48a.6.6 0 0 1 .605-.593h12.79A.6.6 0 0 1 15 4.26v7.479a.6.6 0 0 1-.605.594H1.605A.6.6 0 0 1 1 11.74V4.26Zm10.685 6.407H11.667a.5.5 0 0 1-.407-.21L9.5 8.873a.5.5 0 0 1 .669-.744l.999.899V5.833a.5.5 0 0 1 1 0v3.213l.996-.915a.501.501 0 0 1 .676.738l-1.816 1.666a.5.5 0 0 1-.338.132Zm-4.185 0a.5.5 0 0 1-.5-.5V7.136l-1.628 1.81a.516.516 0 0 1-.743 0L3 7.136v3.03a.5.5 0 0 1-1 0V5.834a.5.5 0 0 1 .872-.334L5 7.864l2.128-2.365A.5.5 0 0 1 8 5.833v4.334a.5.5 0 0 1-.5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PivotCellIcon = createCustomIcon({
  name: "Pivot cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M5 2H2v3h3V2ZM2 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2ZM14 2H8v3h6V2ZM8 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H8ZM5 8H2v6h3V8ZM2 7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H2ZM13.808 9.503 13 8.7V9.5c0 .754-.03 1.363-.137 1.843-.11.491-.31.899-.688 1.182-.361.27-.816.376-1.313.426C10.368 13 9.754 13 9.025 13H8.5l.793.793a.5.5 0 1 1-.707.707l-1.647-1.646a.5.5 0 0 1 0-.707L8.586 10.5a.5.5 0 0 1 .707.707L8.5 12H9c.76 0 1.325 0 1.763-.044.44-.044.673-.127.812-.231.122-.091.234-.247.312-.6.08-.363.113-.878.113-1.625v-.786l-.778.783a.5.5 0 1 1-.71-.704l1.633-1.645a.5.5 0 0 1 .707-.003l1.66 1.648a.5.5 0 1 1-.704.71Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SankeyCellIcon = createCustomIcon({
  name: "Sankey cell",
  category: "Cells / Types",
  path: (
    <>
      {/* Left nodes */}
      <path d="M1 1h2v5H1V1Z" fill="currentColor" fillOpacity=".3" />
      <path d="M1 1h2v5H1V1Z" stroke="currentColor" strokeWidth=".6" />
      <path d="M1 8h2v7H1V8Z" fill="currentColor" fillOpacity=".3" />
      <path d="M1 8h2v7H1V8Z" stroke="currentColor" strokeWidth=".6" />
      {/* Right nodes */}
      <path d="M13 1h2v4h-2V1Z" fill="currentColor" fillOpacity=".3" />
      <path d="M13 1h2v4h-2V1Z" stroke="currentColor" strokeWidth=".6" />
      <path d="M13 7h2v4h-2V7Z" fill="currentColor" fillOpacity=".3" />
      <path d="M13 7h2v4h-2V7Z" stroke="currentColor" strokeWidth=".6" />
      <path d="M13 13h2v2h-2v-2Z" fill="currentColor" fillOpacity=".3" />
      <path d="M13 13h2v2h-2v-2Z" stroke="currentColor" strokeWidth=".6" />
      {/* Flows */}
      <path
        d="M3 2 C6 2, 10 2, 13 2 L13 4 C10 4, 6 4, 3 4 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
      <path
        d="M3 4 C6 4, 10 7, 13 8 L13 10 C10 9, 6 6, 3 6 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
      <path
        d="M3 9 C6 9, 10 8, 13 8 L13 10 C10 10, 6 11, 3 11 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
      <path
        d="M3 12 C6 12, 10 13, 13 13.5 L13 14.5 C10 14, 6 14, 3 14 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
    </>
  ),
});

export const NetworkSankeyCellIcon = createCustomIcon({
  name: "Network Sankey cell",
  category: "Cells / Types",
  path: (
    <>
      {/* Center hub node */}
      <path d="M6 6h4v4H6V6Z" fill="currentColor" fillOpacity=".3" />
      <path d="M6 6h4v4H6V6Z" stroke="currentColor" strokeWidth=".6" />
      {/* Outer nodes - branching pattern */}
      <path d="M1 2h2v3H1V2Z" fill="currentColor" fillOpacity=".3" />
      <path d="M1 2h2v3H1V2Z" stroke="currentColor" strokeWidth=".6" />
      <path d="M1 11h2v3H1v-3Z" fill="currentColor" fillOpacity=".3" />
      <path d="M1 11h2v3H1v-3Z" stroke="currentColor" strokeWidth=".6" />
      <path d="M13 2h2v3h-2V2Z" fill="currentColor" fillOpacity=".3" />
      <path d="M13 2h2v3h-2V2Z" stroke="currentColor" strokeWidth=".6" />
      <path d="M13 11h2v3h-2v-3Z" fill="currentColor" fillOpacity=".3" />
      <path d="M13 11h2v3h-2v-3Z" stroke="currentColor" strokeWidth=".6" />
      {/* Connecting flows - branching from center */}
      <path
        d="M3 3 C5 3, 5 7, 6 7 L6 9 C5 9, 5 5, 3 5 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
      <path
        d="M3 12 C5 12, 5 9, 6 9 L6 7 C5 7, 5 14, 3 14 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
      <path
        d="M10 7 C11 7, 11 3, 13 3 L13 5 C11 5, 11 9, 10 9 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
      <path
        d="M10 9 C11 9, 11 12, 13 12 L13 14 C11 14, 11 7, 10 7 Z"
        fill="currentColor"
        fillOpacity=".15"
      />
    </>
  ),
});

export const PythonLogoIcon = createCustomIcon({
  name: "Python cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M5.19385 1.20417L5.2969 1.16024C5.54489 1.0545 5.8117 1 6.08129 1H9.91871C10.1883 1 10.4551 1.0545 10.7031 1.16024L10.8062 1.20417C11.2528 1.39461 11.6131 1.74375 11.8175 2.1842C11.9377 2.44326 12 2.72542 12 3.01101V4H13C14.1046 4 15 4.89543 15 6V10C15 11.1046 14.1046 12 13 12H12V12.989C12 13.2746 11.9377 13.5567 11.8175 13.8158L10.9104 13.3949C10.9694 13.2677 11 13.1292 11 12.989V12H8V11H11H12H13C13.5523 11 14 10.5523 14 10V6C14 5.44771 13.5523 5 13 5H12V6.00169C12 7.42749 10.8442 8.58333 9.41835 8.58333H6.58165C5.70813 8.58333 5 9.29146 5 10.165V11V12V12.989C5 13.1292 5.03057 13.2677 5.08958 13.3949C5.18992 13.6111 5.36678 13.7825 5.58605 13.8759L5.68909 13.9199L5.30345 14.8244L5.6891 13.9199C5.81309 13.9727 5.9465 14 6.08129 14H9.91871C10.0535 14 10.1869 13.9727 10.3109 13.9199L10.414 13.8759C10.6332 13.7825 10.8101 13.6111 10.9104 13.3949L11.8175 13.8158C11.6131 14.2563 11.2528 14.6054 10.8062 14.7958L10.7031 14.8398C10.4551 14.9455 10.1883 15 9.91871 15H6.08129C5.8117 15 5.54489 14.9455 5.2969 14.8398L5.19385 14.7958C4.74718 14.6054 4.38689 14.2563 4.18249 13.8158C4.06228 13.5567 4 13.2746 4 12.989V12H3C1.89543 12 1 11.1046 1 10V6C1 4.89543 1.89543 4 3 4H4V3.01101C4 2.72542 4.06228 2.44326 4.18249 2.1842C4.38689 1.74375 4.74718 1.39461 5.19385 1.20417ZM2 6C2 5.44772 2.44772 5 3 5H4H5L8 5V4L5 4V3.01101C5 2.87081 5.03057 2.73231 5.08958 2.60514C5.18992 2.38892 5.36678 2.21754 5.58605 2.12405L5.68909 2.08012L5.3246 1.22522L5.68909 2.08012C5.81309 2.02725 5.9465 2 6.08129 2H9.91871C10.0535 2 10.1869 2.02725 10.3109 2.08012L10.414 2.12405C10.6332 2.21754 10.8101 2.38892 10.9104 2.60514C10.9694 2.73231 11 2.87082 11 3.01101V4V5V6.00169C11 6.87521 10.2919 7.58333 9.41835 7.58333H6.58165C5.15584 7.58333 4 8.73918 4 10.165V11H3C2.44772 11 2 10.5523 2 10V6ZM8 13C8 12.7239 8.22386 12.5 8.5 12.5C8.77614 12.5 9 12.7239 9 13C9 13.2761 8.77614 13.5 8.5 13.5C8.22386 13.5 8 13.2761 8 13ZM7.5 2.5C7.22386 2.5 7 2.72386 7 3C7 3.27614 7.22386 3.5 7.5 3.5C7.77614 3.5 8 3.27614 8 3C8 2.72386 7.77614 2.5 7.5 2.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const RLanguageIcon = createCustomIcon({
  name: "R language",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5C10.3012 1.5 12.3231 2.69584 13.4782 4.5H14.635C13.3775 2.1211 10.878 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 10.878 2.1211 13.3775 4.5 14.635V13.4782C2.69584 12.3231 1.5 10.3012 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5ZM12.8737 5.4C12.2 4.8 11.2737 4.5 10.0947 4.5H5.5V15.5H7.64737V11.2833H9.60602L12.0526 15.5H14.5L11.7193 10.9875C12.1148 10.836 12.4991 10.6151 12.8737 10.3C13.5474 9.72222 13.8842 8.89444 13.8842 7.81667C13.8842 6.80556 13.5474 6 12.8737 5.4ZM11.2 9.15C10.9053 9.40556 10.4526 9.53333 9.84211 9.53333H7.64737V6.33333H9.84211C10.4526 6.33333 10.9053 6.46667 11.2 6.73333C11.5053 6.98889 11.6579 7.38889 11.6579 7.93333C11.6579 8.47778 11.5053 8.88333 11.2 9.15Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SQLCellIcon = createCustomIcon({
  name: "SQL cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="m3.52 3.76-.02.03v.19l.03.08c.04.08.14.23.38.4.5.36 1.63.79 4.09.79s3.59-.43 4.09-.78c.24-.18.34-.33.38-.41a.38.38 0 0 0 .03-.08v-.19s0-.02-.02-.03a.97.97 0 0 0-.36-.33c-.51-.3-1.65-.68-4.12-.68s-3.6.37-4.12.68a.97.97 0 0 0-.36.33ZM2.5 3.75h.07-.07v-.03a.72.72 0 0 1 .02-.15c.02-.08.06-.19.12-.3.13-.22.35-.47.73-.7.74-.44 2.1-.82 4.63-.82s3.9.38 4.63.82c.38.23.6.48.73.7a1.17 1.17 0 0 1 .14.45v.02l-.07.01h.07v7.67c0 .65-.26 1.36-.92 1.74A8.99 8.99 0 0 1 8 14.25c-2.27 0-3.76-.6-4.58-1.09a1.97 1.97 0 0 1-.92-1.74V3.75Zm1 5.55v2.12c0 .41.16.73.42.88a8 8 0 0 0 4.08.95 8 8 0 0 0 4.08-.95c.26-.15.42-.47.42-.88V9.3l-.28.15a9.4 9.4 0 0 1-4.22.8 9.4 9.4 0 0 1-4.5-.95Zm9-1.24A8.44 8.44 0 0 1 8 9.25a8.4 8.4 0 0 1-3.78-.7 3.01 3.01 0 0 1-.72-.49V5.4c.78.48 2.13.86 4.5.86s3.72-.38 4.5-.86v2.67Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SectionIcon = createCustomIcon({
  name: "Section",
  category: "Cells / Types",
  tags: ["section", "collapsible"],
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 2C2.22386 2 2 2.22386 2 2.5C2 2.77614 2.22386 3 2.5 3H13.5C13.7761 3 14 2.77614 14 2.5C14 2.22386 13.7761 2 13.5 2H2.5ZM2 4.5C2 4.22386 2.22386 4 2.5 4C2.77614 4 3 4.22386 3 4.5V13.5C3 13.7761 2.77614 14 2.5 14C2.22386 14 2 13.7761 2 13.5V4.5ZM13 5H5V13H13V5ZM5 4C4.44772 4 4 4.44772 4 5V13C4 13.5523 4.44772 14 5 14H13C13.5523 14 14 13.5523 14 13V5C14 4.44772 13.5523 4 13 4H5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleValueIcon = createCustomIcon({
  name: "Single value cell",
  category: "Cells / Types",
  path: (
    <path
      d="M1 3h14v10H1V3ZM0 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3Zm7.4 6.13c-.167.105-.319.21-.463.314l-.012.01c-.131.109-.254.21-.355.32-.104.119-.176.239-.216.366h2.844V11H5.204a2.49 2.49 0 0 1 .351-1.28c.224-.366.536-.68.935-.95.192-.134.392-.269.6-.403.199-.135.39-.27.566-.427.168-.15.312-.314.424-.486.112-.18.168-.381.176-.613a1.74 1.74 0 0 0-.04-.337.88.88 0 0 0-.44-.598 1.078 1.078 0 0 0-.503-.105.906.906 0 0 0-.471.112.793.793 0 0 0-.304.314c-.08.127-.136.285-.168.464-.04.18-.056.374-.064.576h-.95c0-.322.04-.62.127-.898.088-.276.216-.516.392-.718.168-.202.383-.359.631-.478C6.714 5.06 7.001 5 7.33 5c.36 0 .655.06.887.173.24.12.44.269.583.448.152.18.256.374.312.591.063.21.095.412.095.599 0 .232-.032.449-.103.636a2.146 2.146 0 0 1-.296.523c-.12.157-.256.307-.416.442-.16.134-.32.261-.487.381l-.503.337ZM3.064 5.778c.151-.082.28-.18.383-.307.104-.127.168-.284.2-.456h.75v5.984H3.39V6.773H2v-.77c.2 0 .383-.023.567-.053a1.66 1.66 0 0 0 .496-.172Zm10.665 2.499a1.14 1.14 0 0 0-.759-.486v-.015c.272-.097.48-.255.608-.471.127-.217.191-.472.191-.763 0-.255-.048-.48-.151-.674a1.445 1.445 0 0 0-.408-.479 1.697 1.697 0 0 0-.575-.284 2.17 2.17 0 0 0-.655-.097c-.288 0-.543.052-.767.15-.224.097-.424.239-.575.411-.16.172-.288.382-.376.62-.088.24-.144.495-.152.779h.919a1.32 1.32 0 0 1 .048-.434c.04-.142.096-.27.176-.381a.899.899 0 0 1 .295-.27.836.836 0 0 1 .424-.097c.255 0 .471.075.63.224.169.15.249.344.249.591a.85.85 0 0 1-.112.442.824.824 0 0 1-.28.284c-.12.067-.256.12-.407.142-.152.03-.304.038-.456.03v.696c.184-.008.36 0 .535.015.176.015.336.06.472.127a.86.86 0 0 1 .343.3c.088.134.128.306.128.53 0 .33-.104.584-.311.763-.208.18-.464.27-.775.27-.36 0-.631-.12-.815-.352-.184-.232-.264-.524-.256-.875h-.91c.007.299.047.576.135.823.088.247.208.456.376.636.168.171.367.314.615.403.248.098.535.143.863.143.271 0 .527-.038.767-.12.24-.082.455-.202.639-.352.184-.15.327-.336.44-.553.103-.202.159-.45.159-.726 0-.374-.088-.688-.272-.95Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SliderInputIcon = createCustomIcon({
  name: "Input parameter: Slider",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M11 8.5C11 9.32843 10.3284 10 9.5 10C8.67157 10 8 9.32843 8 8.5C8 7.67157 8.67157 7 9.5 7C10.3284 7 11 7.67157 11 8.5ZM11.95 9H16V8H11.95C11.7184 6.85888 10.7095 6 9.5 6C8.29052 6 7.28164 6.85888 7.05001 8H0V9H7.05001C7.28164 10.1411 8.29052 11 9.5 11C10.7095 11 11.7184 10.1411 11.95 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TableCellIcon = createCustomIcon({
  name: "Table cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M3 14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3ZM3 3h2v2H3V3Zm0 3v7h2V6H3Zm3 0v7h7V6H6Zm7-1V3H6v2h7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TextCellIcon = createCustomIcon({
  name: "Text cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M2 2.00006H14V5H13V3.00006H9V13.0001H12V14.0001H4V13.0001H7V3.00006H3V5H2V2.00006Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const WritebackCellIcon = createCustomIcon({
  name: "Writeback cell",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M3.5 3.54a.264.264 0 0 1 .015-.032c.03-.054.12-.18.367-.33C4.392 2.874 5.534 2.5 8 2.5s3.608.373 4.118.679c.247.148.337.275.367.33a.269.269 0 0 1 .015.031v.187a.384.384 0 0 1-.03.081c-.039.083-.136.236-.382.407C11.586 4.567 10.457 5 8 5s-3.586-.433-4.088-.785c-.245-.171-.343-.324-.382-.407a.38.38 0 0 1-.03-.082V3.54Zm-.933-.04H2.5v7.672c0 .652.265 1.359.919 1.741C4.241 13.394 5.731 14 8 14c.186 0 .366-.004.541-.012A4 4 0 0 0 13.5 7.854V3.5h-.067c.067 0 .067-.001.067-.002V3.47a.67.67 0 0 0-.023-.15 1.174 1.174 0 0 0-.118-.296c-.126-.227-.35-.475-.727-.702C11.892 1.877 10.534 1.5 8 1.5s-3.892.377-4.632.821c-.378.227-.6.475-.727.702a1.173 1.173 0 0 0-.137.405.722.722 0 0 0-.003.04v.018l-.001.007v.005l.067.002Zm3.933 7c0 .938.323 1.8.863 2.482-1.717-.098-2.833-.577-3.44-.932-.26-.153-.423-.47-.423-.878V9.048c.085.05.177.1.276.15.617.307 1.506.6 2.765.73a4.001 4.001 0 0 0-.041.572Zm4-4a4.001 4.001 0 0 0-3.689 2.45c-1.247-.111-2.069-.388-2.587-.647a3.011 3.011 0 0 1-.724-.49V5.14C4.278 5.616 5.63 6 8 6s3.722-.384 4.5-.86v1.895a3.981 3.981 0 0 0-2-.535Zm-3 4a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM10 9a.5.5 0 0 1 1 0v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1H9a.5.5 0 0 1 0-1h1V9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ButtonInputIcon = createCustomIcon({
  name: "Input parameter: Button",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M4 13.3938L13 8.19764L4 3.00149L4 13.3938ZM13.5 9.06367C14.1667 8.67877 14.1667 7.71652 13.5 7.33162L4.5 2.13547C3.83333 1.75057 3 2.23169 3 3.00149L3 13.3938C3 14.1636 3.83333 14.6447 4.5 14.2598L13.5 9.06367Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CheckboxInputIcon = createCustomIcon({
  name: "Input parameter: Checkbox",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M3 3h10v10H3V3ZM2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3Zm5.161 7.954 4.154-4.848-.76-.65-3.45 4.028-1.687-1.687-.707.707 2.45 2.45Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DropdownInputIcon = createCustomIcon({
  name: "Input parameter: Dropdown",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="m8.007 1.828 4.646 4.309-.68.733-3.98-3.691-4.16 3.698-.665-.748 4.84-4.301ZM8 12.834 3.832 9.13l-.664.748L8 14.172l4.832-4.295-.664-.748L8 12.834Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MultiselectInputIcon = createCustomIcon({
  name: "Input parameter: Multiselect",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M6 2h8v8h-1v1h1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1h1V2ZM2 6v8h8V6H2Zm0-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2Zm3.275 7.664L8.93 8.397l-.76-.651-2.953 3.447-1.416-1.416-.707.707 2.18 2.18Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const NumericInputIcon = createCustomIcon({
  name: "Input parameter: Numeric input",
  category: "Cells / Types",
  path: (
    <path
      clipRule="evenodd"
      d="M7.09806 2.50971C7.36884 2.56387 7.54445 2.82728 7.49029 3.09806L7.0099 5.5H9.9901L10.5097 2.90195C10.5639 2.63117 10.8273 2.45556 11.0981 2.50971C11.3688 2.56387 11.5444 2.82728 11.4903 3.09806L11.0099 5.5H13C13.2761 5.5 13.5 5.72386 13.5 6C13.5 6.27615 13.2761 6.5 13 6.5H10.8099L10.2099 9.5H13C13.2761 9.5 13.5 9.72386 13.5 10C13.5 10.2761 13.2761 10.5 13 10.5H10.0099L9.49029 13.0981C9.43613 13.3688 9.17272 13.5445 8.90194 13.4903C8.63116 13.4361 8.45555 13.1727 8.50971 12.9019L8.9901 10.5H6.0099L5.49029 13.0981C5.43613 13.3688 5.17272 13.5445 4.90194 13.4903C4.63116 13.4361 4.45555 13.1727 4.50971 12.9019L4.9901 10.5H3C2.72386 10.5 2.5 10.2761 2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H5.1901L5.7901 6.5H3C2.72386 6.5 2.5 6.27615 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H5.9901L6.50971 2.90195C6.56387 2.63117 6.82728 2.45556 7.09806 2.50971ZM6.8099 6.5L6.2099 9.5H9.1901L9.7901 6.5H6.8099Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});
